import React from 'react'
import {
   ThaiMeaningEngTranslation,
   ThaiMeaningBasicProps,
} from 'core/interfaces/dictionary-thai-interfaces'
import ThaiWordListExplanation from './thai-word-list-explanation'
import { getExplanationType } from '../../../../lib/translation-explanations'
import ThaiWordMeaningText from '../thai-word-meaning-text'
import ThaiWordListContext from './thai-word-list-context'

type Props = {
   meaning: ThaiMeaningBasicProps
   engTranslationWords: ThaiMeaningEngTranslation[] | undefined
}

const ThaiWordListMeaning = (props: Props) => {
   if (!props.meaning) return null
   const { meaning } = props

   const explanationType = getExplanationType(meaning.explanation, meaning.meaning)

   return (
      <div className="flex relative items-baseline flex-row m-0 flex-wrap leading-[1.3]">
         <ThaiWordMeaningText meaning={meaning} engTranslationWords={props.engTranslationWords} />
         <ThaiWordListContext explanation={meaning.explanation} explanationType={explanationType} />
         <ThaiWordListExplanation
            explanation={meaning.explanation}
            explanationType={explanationType}
         />
      </div>
   )
}

export default ThaiWordListMeaning
